import { AccordionNextGen } from './AccordionNextGen'
import { reactToCwp } from '../../../common/react-utils'

export default reactToCwp(AccordionNextGen)
